import { loanActionApiV2 } from 'app/services/api';

export const executeSendFormBundles = (applicationId, action) =>
  loanActionApiV2.executeLoanAction({
    applicationId,
    loanActionId: action.id,
    metadata: null,
  });

// Dispatches the SAME MailDocumentPackage loan action the "Mail Document Package" manual button
// runs (LoanActionsGroup / SkynetAPI's MailDocumentPackageExecutor). Today the executor always
// mails the loan's primary borrower (it has no per-recipient targeting yet), so this fires once —
// not once per mail-chosen signer — regardless of how many co-borrowers/NBEs also chose Mail.
export const executeMailDocumentPackage = (applicationId, action) =>
  loanActionApiV2.executeLoanAction({
    applicationId,
    loanActionId: action.id,
    metadata: null,
  });
